var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 11.9688C8.49123 11.9688 9.4375 12.915 9.4375 14.0781V16.8906C9.4375 18.0537 8.49123 19 7.32812 19H3.10938C1.94627 19 1 18.0537 1 16.8906V14.0781C1 12.915 1.94627 11.9688 3.10938 11.9688H7.32812ZM16.8906 9.15625C18.0537 9.15625 19 10.1025 19 11.2656V16.8906C19 18.0537 18.0537 19 16.8906 19H12.6719C11.5088 19 10.5625 18.0537 10.5625 16.8906V11.2656C10.5625 10.1025 11.5088 9.15625 12.6719 9.15625H16.8906ZM7.32812 1C8.49123 1 9.4375 1.94627 9.4375 3.10938V8.73438C9.4375 9.89748 8.49123 10.8438 7.32812 10.8438H3.10938C1.94627 10.8438 1 9.89748 1 8.73438V3.10938C1 1.94627 1.94627 1 3.10938 1H7.32812ZM16.8906 1C18.0537 1 19 1.94627 19 3.10938V5.92188C19 7.08498 18.0537 8.03125 16.8906 8.03125H12.6719C11.5088 8.03125 10.5625 7.08498 10.5625 5.92188V3.10938C10.5625 1.94627 11.5088 1 12.6719 1H16.8906Z",
    fill: "url(#paint0_linear_6_14050)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_14050",
    x1: 10,
    y1: 19,
    x2: 10,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e0d5b3842ab029d6e68282f32336d1e9.svg";
export { ForwardRef as ReactComponent };